export const countyNames = {
  0: 'شهرستان‌ها',
  1: 'بابلسر',
  2: 'بابل',
  3: 'آمل',
  4: 'بهشهر',
  5: 'تنکابن',
  6: 'جویبار',
  7: 'چالوس',
  8: 'رامسر',
  9: 'سوادکوه',
  10: 'سوادکوه شمالی',
  11: 'سیمرغ',
  12: 'عباس‌آباد',
  13: 'فریدونکنار',
  14: 'قائم‌شهر',
  15: 'کلاردشت',
  16: 'گلوگاه',
  17: 'محمودآباد',
  18: 'میاندورود',
  19: 'نکا',
  20: 'نور',
  21: 'نوشهر',
  27: 'ساری'
};

export const countyNameToId = {
  Sari: 27,
  Amol: 3,
  Babol: 2,
  Babolsar: 1,
  Behshahr: 4,
  Tonekabon: 5,
  Juybar: 6,
  Chalus: 7,
  Ramsar: 8,
  Savadkuh: 9,
  'North-Savadkuh': 10,
  Simorgh: 11,
  Abbasabad: 12,
  Fereydunkenar: 13,
  'Qaem-Shahr': 14,
  Kelardasht: 15,
  Galugah: 16,
  Mahmudabad: 17,
  Miandorud: 18,
  Neka: 19,
  Nur: 20,
  Nowshahr: 21,
};